import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/404'

import Dashboard from '@/pages/Dashboard'
import OrderList from '@/pages/OrderList'
import PDFChecks from '@/pages/PDFChecks'
import MailList from '@/pages/MailList'
import About from '@/pages/About'
import Unpaid from '@/pages/Unpaid'
import WorkerList from '@/pages/WorkerList'
import WorkerForm from '@/pages/WorkerForm'
import Extention from '@/pages/Extention'
import BlackList from '@/pages/BlackList'
import BlackForm from '@/pages/BlackForm'
import Contragents from '@/pages/ContragentList'
import ContragentForm from '@/pages/ContragentForm'
import Login from '@/components/Login'

Vue.use(Router)

import auth from '@/utils/auth'

function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default new Router({
  base: __dirname,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/404', component: ErrorPage, name: 'ErrorPage' },
    { path: '/dashboard', component: Dashboard, name: 'Dashboard', beforeEnter: requireAuth },
    { path: '/about', component: About, name: 'About', beforeEnter: requireAuth },
    { path: '/unpaid', component: Unpaid, name: 'Unpaid', beforeEnter: requireAuth },
    { path: '/pdfchecks', component: PDFChecks, name: 'PDFChecks', beforeEnter: requireAuth },
    { path: '/mail', component: MailList, name: 'MailList', beforeEnter: requireAuth },
    { path: '/orders', component: OrderList, name: 'Orders', beforeEnter: requireAuth },
    { path: '/workers', component: WorkerList, name: 'Workers', beforeEnter: requireAuth },
//    { path: '/extention', component: Extention, name: 'Extention', beforeEnter: requireAuth },
    { path: '/worker', component: WorkerForm, name: 'Worker', beforeEnter: requireAuth },
    { path: '/blacklist', component: BlackList, name: 'BlackList', beforeEnter: requireAuth },
    { path: '/blackform', component: BlackForm, name: 'BlackForm', beforeEnter: requireAuth },
    { path: '/contragents', component: Contragents, name: 'Contragents', beforeEnter: requireAuth },
    { path: '/contragent', component: ContragentForm, name: 'ContragentForm', beforeEnter: requireAuth },
    { path: '/login', component: Login, name: 'Login' },
    { path: '/logout',
      beforeEnter (to, from, next) {
        auth.logout()
        next('/login')
      }
    },
    { path: '/', redirect: '/pdfchecks' },
    { path: '*', redirect: '/404' }
  ],
  meta: {
    progress: {
      func: [
        {call: 'color', modifier: 'temp', argument: '#ffb000'},
        {call: 'fail', modifier: 'temp', argument: '#6e0000'},
        {call: 'location', modifier: 'temp', argument: 'top'},
        {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
      ]
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js